module.exports = __webpack_public_path__ + "img/all-dark.542a5b74.svg";